// extracted by mini-css-extract-plugin
export default {"container":"Shop_container__pZxi4","mainSection":"Shop_mainSection__rFqjN","container__error":"Shop_container__error__5e95Z"};